'use client';
import { createSafeContext } from '@s7/react-utils';
import { CompoundRootRequiredError } from '@s7/system';
import { IDENT_MODAL } from './Modal.contract.js';

const [ModalProvider, useModalContext] = createSafeContext(new CompoundRootRequiredError('ui', IDENT_MODAL));

export { ModalProvider, useModalContext };
//# sourceMappingURL=Modal.context.js.map
